import { useEffect, useRef } from "react";

import searchImg from "../../../../assets/search.png";
import { CustomAvatar } from "../../../../components/avatar/CustomAvatar";
import { useMenuContext } from "../../../../context/MenuContext";
import { useInfoUser } from "../../../../store/UserStore";
import { formatShortTime } from "../../../../utils/formatTime";
import { highlightText } from "../../../../utils/Utils";
import "./SearchMessageList.scss";

const SearchMessageBox = ({
  jumpToMessage,
  message,
  userList,
  searchValue,
}) => {
  const { user, languageMap } = useInfoUser();
  const { selectedMessageId } = useMenuContext();

  const normalizeText = (text) => text.replace(/\s+/g, " ").trim();
  const getDisplayMessageWithsearchValue = (
    text,
    searchValue,
    maxLength = 45,
  ) => {
    if (!text || typeof text !== "string") return "";

    text = normalizeText(text);

    if (!searchValue || typeof searchValue !== "string") {
      return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    }

    const lowerText = text.toLowerCase();
    const lowersearchValue = searchValue.toLowerCase();
    const index = lowerText.indexOf(lowersearchValue);

    if (index === -1) {
      return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
    }

    const start = Math.max(
      0,
      index - Math.floor((maxLength - searchValue.length) / 2),
    );
    const end = start + maxLength;
    const sliced = text.slice(start, end);

    return (start > 0 ? "..." : "") + sliced + (end < text.length ? "..." : "");
  };

  const time = message?.createdAt
    ? formatShortTime(new Date(message.createdAt), languageMap, user?.language)
    : "";

  const contentMap = {
    TEXT: message?.content,
    IMAGE: message?.content,
    FILE: message?.shortName,
  };

  const messageText = contentMap[message?.contentType] || "";

  const displayMessage = getDisplayMessageWithsearchValue(
    messageText,
    searchValue,
  );
  const person = userList?.find((u) => u?.userId === message?.senderId);

  return (
    <button
      className={`search-conversation w-[100%] ${selectedMessageId === message?.messageId ? "selectedConversation" : ""}`}
      onClick={() => {
        jumpToMessage(message);
      }}
    >
      <div className="relative flex self-center">
        <CustomAvatar
          person={person}
          userId={person?.senderId}
          size={40}
          pos={-1}
          styleCss={{}}
        />
      </div>
      <div className="w-[100%]">
        <div className="conversation-name">
          <div className="name">{person?.name}</div>
          <div className="time-and-bell text-[12px]">{time}</div>
        </div>
        <div className="conversation-content-message">
          <div
            className="last-message highlight-search
           w-[270px]"
          >
            {highlightText(displayMessage, searchValue)}
          </div>
        </div>
      </div>
    </button>
  );
};

const SearchMessageList = ({
  jumpToMessage,
  messageList,
  userList,
  fetchMoreMessageInChat,
  isLoading,
  isMoreMessage,
  searchValue,
}) => {
  const lastObserver = useRef();

  const lastMessageRef = (node) => {
    if (isLoading || !isMoreMessage) return;
    if (lastObserver.current) {
      lastObserver.current.disconnect();
    }

    lastObserver.current = new IntersectionObserver(async ([entry]) => {
      if (!entry?.isIntersecting) return;
      await fetchMoreMessageInChat();
    });

    if (node) lastObserver.current.observe(node);
  };

  useEffect(() => {
    return () => {
      if (lastObserver.current) lastObserver.current.disconnect();
    };
  }, []);

  if (messageList?.length === 0) {
    return (
      <div className="message-list">
        {/* Break line height is 2 px */}
        <div className="px-[16px] py-[8px] border-b-[1px]"></div>
        <div className="flex flex-col items-center">
          <img src={searchImg} alt="Cover" className="w-[40%]" />
          <div className="px-[44px] text-center text-[#5a6981]">
            No results found
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="message-list">
      {/* Break line height is 2 px */}
      <div className="px-[16px] py-[8px] border-b-[1px]"></div>
      <div
        className="conversation-container"
        style={{
          maxHeight: `${window.innerHeight - 67 - 106 - 2 - 35}px`,
        }}
      >
        {messageList?.map((message, index) => (
          <div
            className={`${index !== messageList?.length - 1 && "border-b-[1px]"}`}
            key={message?.messageId}
            ref={index === messageList?.length - 1 ? lastMessageRef : null}
          >
            <SearchMessageBox
              jumpToMessage={jumpToMessage}
              message={message}
              userList={userList}
              searchValue={searchValue}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export { SearchMessageList };
